import React from "react";
import { XAxis, Tooltip, ResponsiveContainer, Line, LineChart, YAxis, LabelList, Legend } from "recharts";
import "./lineChart.styles.scss";
const COLOR = ["#4b9793", "#fe9f4c", "#4d79a8", "#91ce7e", "#d57297", "#4d4f5c"];


const CustomizedLegend = (props) => {
  if (props.external.length) {
    let legendArray = Object.keys(props.external[0])
    legendArray.shift()
    return (
      <ul style={{ listStyle: 'none', display: 'flex', justifyContent: 'center', fontSize: '12px', fontWeight: 600 }}>
        {
          legendArray.map((entry, index) => (
            <li key={`item-${index}`} style={{ display: 'flex', marginRight: '16px', alignItems: 'center' }}>
              <span style={{ width: '12px', height: '8px', backgroundColor: `${COLOR[index]}`, marginRight: '8px', borderRadius: '10px' }}>
              </span>
              <span>
                {entry}
              </span>
            </li>
          ))
        }
      </ul>
    );
  } else {

    return " "
  }
}

const CustomizedLabel = (props) => {
  const { x, y, stroke, value } = props;
  return <g><text x={x + 10}
    y={y}
    dy={-4}
    fill={stroke}
    fontSize={10}
    textAnchor="middle"
  >
    {value?.toFixed(2)}</text></g>

}

const renderTooltip = (e) => {
  return (
    <div className="dtts-tooltip">
      <span>{e.label}</span>
      <span className='dtts-tooltip-values'>
        {
          e.payload && e.payload.map((item, ind) => (
            <span key={ind} style={{ color: e.payload[ind].color }}>{e.payload[ind].dataKey} : {(item.value).toFixed(2)}</span>
          ))
        }
      </span>
    </div>
  )
}

const TTSLineChart = (props) => {

  let convertToArray = props?.data[0];
  let mapLineChart = convertToArray && Object.keys(convertToArray);
  mapLineChart && mapLineChart.shift();

    return (
      <>
        <ResponsiveContainer height="100%" width="105%">
          <LineChart
            width={550}
            height={180}
            data={props?.data}
            margin={{
              top: 5,
              right: 60,
              left: 5,
              bottom: 5,
            }}
          >
            <YAxis axisLine={{ stroke: '#e6e6e7' }} style={{ fontSize: "12px" }} tickLine={false} padding={{ top: 35 }} tickFormatter={tick => { return tick + '%' }} />
            <XAxis axisLine={{ stroke: '#e6e6e7' }} dataKey="YearNo" style={{ fontSize: "12px" }} tickLine={false} />
            <Tooltip content={(e) => renderTooltip(e)} />
            <Legend height={25} content={<CustomizedLegend external={props.data} />} />

            {
              mapLineChart && mapLineChart.map((item, ind) => (
                <Line key={ind} type="linear" dataKey={`${item}`} stroke={`${COLOR[ind]}`} dot={false} strokeWidth={2} >
                  <LabelList fontSize={10} content={<CustomizedLabel myProps={props.data ? props.data : []} />} />
                </Line>

              ))
            }
           
          </LineChart>
        </ResponsiveContainer>
       
      </>
    );
  }

export default TTSLineChart;